<template>
    <div class="form-field" :class="{ required }">

        <ValidationProvider :key="name" :name="name" v-slot="{ errors }" persist :rules="rules">

            <div class="form-group">

                <label :for="name" class="form-field-label"
                       :class="{'validation-error': errors.length > 0 }">{{label}}</label>

                <input class="form-control" :class="{'validation-error': errors.length > 0 }"
                       :name="name"
                       v-bind:value="value"
                       @input="$emit('input', $event.target.value)"
                       :type="type ? type : 'text'"
                       :placeholder="placeholder"
                >

                <p v-if="errors[0]" class="validation-error">{{ errors[0] }}</p>

            </div>

        </ValidationProvider>

    </div>
</template>

<script>
    import {ValidationProvider} from "vee-validate"

    export default {
        name: "TextInput",
        props: ["name", "value", "label", "type", "placeholder", "rules", "required"],
        components: {
            ValidationProvider
        }
    }
</script>

<style lang="scss" scoped>
    .required {

        .form-field-label:after {
            content: '*';
            color: red;
        }
    }
</style>
